import React, { useContext, useState } from 'react';
import * as R from 'ramda';
import Box from '@mui/material/Box';

import { DrawerContext } from 'common/drawer/DrawerContext';
import { ClickAwayListener } from '@mui/material';
import ConfigurationStep from './ConfigurationStep';
import ConfigurationStepVolume from './ConfigurationStepVolume';
import SummaryStep from './OneToOneSummaryStep';

const initialState = {
  fromLocation: null,
  inventoryOwner: null,
  origin: [],
  product: null,
  rvp: null,
  toLocation: null,
  transferDate: null,
};

const OneToOneDrawer = ({ ...props }) => {
  const { setDrawerComponentProps } = useContext(DrawerContext);

  const [step, setStep] = useState(1);
  const [reconsignmentState, setReconsignmentState] = useState(initialState);
  const [openDialog, setOpenDialog] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const next = () => {
    setStep(R.inc);
  };

  //   TODO: Implement the prev and reset functions
  const prev = () => {
    setStep(R.dec);
  };
  const reset = () => {
    setStep(1);
    setReconsignmentState(initialState);
    setIsSuccess(false);
  };

  const handleDrawerClose = () => {
    setDrawerComponentProps({
      Component: '',
      forceCloseSelector: () => false,
      holdOpenSelector: () => false,
      refreshNotifications: false,
      resetWizard: undefined,
      setCurrentDialogOpen: () => {},
      type: '',
    });
  };

  const onClose = () => {
    const omitFields = R.omit(['transferDate', 'inventoryOwner']);
    if (isSuccess || R.equals(omitFields(reconsignmentState), omitFields(initialState))) {
      handleDrawerClose();
    } else {
      setOpenDialog(true);
    }
  };

  return (
    <ClickAwayListener
      mouseEvent="onMouseDown"
      onClickAway={() => {
        onClose();
      }}
      touchEvent="onTouchStart"
    >
      <Box height={1} sx={{ zIndex: 9999 }} width={390}>
        {step === 1 && (
          <ConfigurationStep
            handleDrawerClose={handleDrawerClose}
            next={next}
            onClose={handleDrawerClose}
            openDialog={openDialog}
            prev={prev}
            reconsignmentState={reconsignmentState}
            reset={reset}
            setOpenDialog={setOpenDialog}
            setReconsignmentState={setReconsignmentState}
            {...props}
          />
        )}
        {step === 2 && (
          <ConfigurationStepVolume
            handleDrawerClose={handleDrawerClose}
            next={next}
            onClose={handleDrawerClose}
            openDialog={openDialog}
            prev={prev}
            reconsignmentState={reconsignmentState}
            reset={reset}
            setOpenDialog={setOpenDialog}
            setReconsignmentState={setReconsignmentState}
            {...props}
          />
        )}
        {step === 3 && (
          <SummaryStep
            handleDrawerClose={handleDrawerClose}
            isSuccess={isSuccess}
            next={next}
            onClose={handleDrawerClose}
            openDialog={openDialog}
            prev={prev}
            reconsignmentState={reconsignmentState}
            reset={reset}
            setIsSuccess={setIsSuccess}
            setOpenDialog={setOpenDialog}
            setReconsignmentState={setReconsignmentState}
            {...props}
          />
        )}
      </Box>
    </ClickAwayListener>
  );
};

export default OneToOneDrawer;
